export const BLOG_PAGE_PATH_PART = 'blog/';
